<template>
    <header>
        <h2
            class="mb-2 mb-sm-0"
            style="min-height: 32px; line-height: 32px"
            v-text="title"
        />
    </header>
</template>
<script setup>
defineProps({
    title: String,
});
</script>
